import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/projects";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-32 md:py-44"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12" dir="rtl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          className="flex items-center mb-14"
          dir="ltr"
        >
          <span className="h-rule" />
          <span className="overline">05 — Testimonials</span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.1 }}
          className="font-arabic text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.25] mb-14 max-w-3xl"
        >
          آراء العملاء <span className="text-[#FD1843] glow-text">والطلاب</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.9, delay: i * 0.08 }}
              className="relative bg-white/[0.025] backdrop-blur-xl border border-white/10 rounded-sm p-8 md:p-10 group hover:border-[#FD1843]/40 transition-all duration-500 font-arabic"
            >
              <Quote
                className="text-[#FD1843]/40 group-hover:text-[#FD1843] transition-colors scale-x-[-1]"
                size={28}
              />
              <blockquote className="mt-6 text-white/90 text-lg md:text-xl font-medium leading-[1.95] tracking-tight">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-white/5">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#FD1843] to-[#DC0F37] grid place-items-center text-[#171717] font-display font-bold">
                  {t.name[0]}
                </div>
                <div>
                  <div className="text-white font-bold tracking-tight">{t.name}</div>
                  <div className="text-white/50 text-sm font-medium">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
